const IconTerm = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66673 23.2447H17.3339C19.4133 23.2447 20.4479 22.19 20.4479 20.1007V10.9803C20.4479 9.68427 20.3073 9.12198 19.5037 8.29827L13.9589 2.66341C13.196 1.87956 12.5729 1.70898 11.438 1.70898H6.66673C4.59759 1.70898 3.55273 2.77356 3.55273 4.86327V20.1007C3.55273 22.1998 4.59759 23.2447 6.66673 23.2447ZM6.74688 21.6277C5.71231 21.6277 5.16973 21.0748 5.16973 20.0707V4.89327C5.16973 3.89898 5.71231 3.32598 6.75716 3.32598H11.2169V9.16227C11.2169 10.4278 11.8597 11.0506 13.1052 11.0506H18.8309V20.0707C18.8309 21.0748 18.2982 21.6277 17.2537 21.6277H6.74688ZM13.286 9.53341C12.8943 9.53341 12.7332 9.37313 12.7332 8.97113V3.63756L18.5189 9.53384L13.286 9.53341ZM15.6967 13.8127H8.07245C7.71116 13.8127 7.45016 14.084 7.45016 14.4256C7.45016 14.777 7.71159 15.0483 8.07288 15.0483H15.6967C15.7789 15.0496 15.8605 15.0344 15.9366 15.0036C16.0128 14.9728 16.0819 14.9269 16.14 14.8688C16.1981 14.8108 16.2439 14.7416 16.2748 14.6654C16.3056 14.5893 16.3208 14.5077 16.3194 14.4256C16.3194 14.084 16.0482 13.8127 15.6967 13.8127ZM15.6967 17.3184H8.07245C7.71116 17.3184 7.45016 17.5996 7.45016 17.951C7.45016 18.2926 7.71159 18.554 8.07288 18.554H15.6967C16.0482 18.554 16.3194 18.2926 16.3194 17.951C16.3194 17.5996 16.0482 17.3184 15.6967 17.3184Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconTerm;
